<template>
  <article class="auction_edit">
    <group class="edit_item">
      <cell primary="none" title="车辆照片" :link="`/auction/carInfo/photo/${id}/${source}`">
        <span slot="value" :class="getStatus(brief.is_images_ready)">
          {{brief.is_images_ready['completed'] ? '已完成':'未完成'}}
        </span>
      </cell>
    </group>
    <group class="edit_item">
      <cell primary="none" title="车辆信息" :link="`/auction/carInfo/detail/${id}/${source}`">
        <span slot="value" :class="getStatus(brief.is_details_ready)">
          {{brief.is_details_ready['completed'] ? '已完成':'未完成'}}
        </span>
      </cell>
    </group>
    <group class="edit_item">
      <cell primary="none" title="检测信息" :link="`/auction/carInfo/inspections/${id}/${source}`">
        <span slot="value" :class="getStatus(brief.is_inspections_ready)">
          {{brief.is_inspections_ready['completed'] ? '已完成':'未完成'}}
        </span>
      </cell>
    </group>
    <group class="edit_item" v-if="source==='auction'">
      <cell primary="none" title="收车信息" :link="`/auction/carInfo/recycle/${id}/${source}`">
        <span slot="value" :class="getStatus(brief.is_purchase_ready)">
          {{brief.is_purchase_ready['completed'] ? '已完成':'未完成'}}
        </span>
      </cell>
    </group>

    <div class="tip-info" v-if="brief.latest_car_info_employee_name">
      <p class="result-info">最近编辑：{{brief.latest_car_info_at}}</p>
      <p class="result-info">{{brief.latest_car_info_employee_name}}，{{brief.latest_car_info_employee_role}}</p>
    </div>
    <footer-btn title="提交" :is-ready="isOK" v-if="!noOperate" @submit="toSave"></footer-btn>
  </article>
</template>
<script>
// 新增二手车或者编辑页面
import cache from '../../../common/cache'
import { Cell, Group } from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import { edit } from './restConfig'

export default {
  components: {
    Cell,
    Group,
    FooterBtn
  },
  data() {
    return {
      id: null,
      ticketId: '', // 线索id
      source: null,
      noOperate: false,
      isOK: false,
      isSubmiting: false, // 是否正在提交请求
      brief: {
        is_images_ready: {
          saved: false,
          completed: false
        },
        is_details_ready: {
          saved: false,
          completed: false
        },
        is_inspections_ready: {
          saved: false,
          completed: false
        },
        is_purchase_ready: {
          saved: false,
          completed: false
        },
        latest_car_info_employee_name: null
      }
    }
  },
  created() {
    this.isSubmiting = false // 初始化提交状态
    // 线索id
    this.ticketId = this.$route.query.ticketId || ''
    cache.setSessionData('CAR_INFO_TICKET_ID', this.ticketId)
    this.id = this.$route.params.id
    this.source = this.$route.params.source
    this.noOperate = this.$route.query.noOperate
    this.$rest.carInfo.query(null, edit.getCarInfo[this.source](this.id)).then(res => {
      if (res.code === 0) {
        this.brief = res.data
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    toSave() {
      if (!this.isOK && !this.isSubmiting) {
        this.isSubmiting = true
        this.$rest.carInfo.submitEvaluate(null, edit.saveCarInfo[this.source](this.id)).then(res => {
          if (res.code === 0) {
            let id = res.data.auction_car_id || res.data.ticket_id
            this.$router.push({ path: `/auction/carInfo/success/${id}/${this.source}` })
          } else {
            this.showToast(res.message)
          }
        }).finally(() => {
          this.isSubmiting = false
        })
      }
    },
    getStatus(status) {
      if (status['completed']) {
        return 'is_completed'
      } else if (status['saved']) {
        return 'is_saved'
      }
    }
  },
  watch: {
    'brief'(val) {
      let fields = ['is_images_ready', 'is_details_ready', 'is_inspections_ready']
      if (this.source === 'auction') fields.push('is_purchase_ready')
      this.isOK = fields.some(v => {
        let itemReady = val[v]
        return itemReady && !itemReady.completed
      })
    }
  }
}

</script>
<style lang="less">
@import '../../../stylesheets/base/fn';
.auction_edit {
  padding-top: 20/@w2;
  .edit_item .weui_cells{
    margin-left: 60/@w2;
    margin-right: 60/@w2;
    border: 1px solid #3b5999;
    border-radius: 8/@w2;
  }
  .type {
    padding-right: 20/@w2;
  }
  .is_saved {
    color: #fb3f3f;
  }
  .is_completed {
    color: #1aad19;
  }
  .weui_cell_bd>div {
    margin-right: 20/@w2;
  }
  .weui_cell {
    justify-content: center;
    padding: 60/@w2 30/@w2;
  }
  .tip-info {
    margin-top: 40/@w2;
    line-height: 36/@w2;
    text-align: center;
    padding: 0 30/@w2;
    .result-info {
      opacity: 0.7;
    }
  }
}

</style>
